import http from "../http";

/**
 * run io sim by verificationId
 * 2023/05/30
 * @param {string} id  ->io sim verificationId
 * */
export function runHimalayasIoSim({ verificationId, workflowTypes = [] }) {
  return http.post(`/Himalayas/IoSim/simulation?verificationId=${verificationId}`, workflowTypes);
}